const SIDE_PANEL_ERRORS = {
    surfaceUnavailable: 'No side-panel surface is currently registered.',
    panelNotDeclared: 'The requested side panel is not declared by an owner.',
    subjectMissing: 'An entity side panel requires a subject.',
    commandHandlerFailed: 'The side-panel owner command handler failed.',
    surfaceConflict: 'Only one side-panel surface may be registered at a time.',
    providerMissing: 'Side-panel hooks must be used within SidePanelSystemProvider.',
    affordancePermissionMissing: 'The side-panel definition is missing an affordance permission.'
};

export class SidePanelSurfaceUnavailableError extends Error {
    constructor(message = SIDE_PANEL_ERRORS.surfaceUnavailable) {
        super(message);
        this.name = 'SidePanelSurfaceUnavailableError';
    }
}

export class SidePanelNotDeclaredError extends Error {
    constructor(message = SIDE_PANEL_ERRORS.panelNotDeclared) {
        super(message);
        this.name = 'SidePanelNotDeclaredError';
    }
}

export class SidePanelSubjectMissingError extends Error {
    constructor(message = SIDE_PANEL_ERRORS.subjectMissing) {
        super(message);
        this.name = 'SidePanelSubjectMissingError';
    }
}

export class SidePanelCommandHandlerError extends Error {
    constructor(message = SIDE_PANEL_ERRORS.commandHandlerFailed) {
        super(message);
        this.name = 'SidePanelCommandHandlerError';
    }
}

export class SidePanelSurfaceConflictError extends Error {
    constructor(message = SIDE_PANEL_ERRORS.surfaceConflict) {
        super(message);
        this.name = 'SidePanelSurfaceConflictError';
    }
}

export class SidePanelProviderMissingError extends Error {
    constructor(message = SIDE_PANEL_ERRORS.providerMissing) {
        super(message);
        this.name = 'SidePanelProviderMissingError';
    }
}

export class SidePanelAffordancePermissionMissingError extends Error {
    constructor(panelId: string) {
        super(`${SIDE_PANEL_ERRORS.affordancePermissionMissing} Panel id: "${panelId}".`);
        this.name = 'SidePanelAffordancePermissionMissingError';
    }
}
